import React from "react"

export function Description({content}: { content: string }){
  return (
    <p className="svv-form-description">
      {content}
    </p>
  )
}
